import { manquesDeLOeuvre } from '@artosera/shared';
import { useTranslation } from 'react-i18next';
import { useOeuvre } from '../../api/oeuvres.js';
import { ManquesFiche } from '../oeuvres/ManquesFiche.js';

export function AvertissementSalle({
  galerieSlug,
  oeuvreId,
}: {
  galerieSlug: string;
  oeuvreId: string;
}) {
  const { t } = useTranslation('regie');
  const fiche = useOeuvre(galerieSlug, oeuvreId);
  if (fiche.isPending) return <p role="status">{t('viewingRooms.verificationFiche')}</p>;
  if (!fiche.data) return <p role="status">{t('viewingRooms.verificationIndisponible')}</p>;
  const manques = manquesDeLOeuvre(fiche.data.oeuvre, 'salle', {
    languePrincipale: 'fr',
    siteBilingue: false,
    creditPhotoPrincipal: null,
  });
  return <ManquesFiche manques={manques} />;
}
